module.exports = __webpack_public_path__ + "2cb4df0a0e3875c3c113a239aa7f0570.svg";